module.exports = __webpack_public_path__ + "img/logo.23d0a4c3.png";